module.exports = __webpack_public_path__ + "static/deco-noel-e590bea237105854d5736d3ea102f34a.jpg";